var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoods(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "46px",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "48px_box-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "48px_box-2",
    fill: "#979797"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,12 L30,25 C30,25.5522847 29.5522847,26 29,26 L17,26 C16.4477153,26 16,25.5522847 16,25 L16,12 L0,12 L0,44 C2.22044605e-16,45.1045695 0.8954305,46 2,46 L44,46 C45.1045695,46 46,45.1045695 46,44 L46,12 L30,12 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.659,10 L45.362,10 L33.641,0.231 C33.4610985,0.0817814879 33.2347321,7.7369628e-05 33.001,0 L25.373,0 L29.659,10 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.341,10 L20.627,0 L13,0 C12.766,0 12.54,0.082 12.36,0.231 L0.638,10 L16.341,10 Z",
    id: "Path"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoods);
export default __webpack_public_path__ + "static/media/goods.92823b66adb0428d1498871c113ef873.svg";
export { ForwardRef as ReactComponent };